import type { Currency } from '@sequencehq/api'

import { BaseCreditNoteLineItemDrawer } from 'CreditNotes/components/drawers/BaseCreditNoteLineItemDrawer'

import { CreditNoteLineItemRow } from './CreditNoteLineItemTable'
import { rowToFormValues, submitValuesToRowFields } from './creditNoteRowForm'

type Props = {
  isOpen: boolean
  onClose: () => void
  currency: Currency
  row: CreditNoteLineItemRow
  /** Products used by OTHER rows; hidden from the product select. */
  excludedProductIds: string[]
  onUpdate: (row: CreditNoteLineItemRow) => void
}

export const EditLineItem = ({
  isOpen,
  onClose,
  currency,
  row,
  excludedProductIds,
  onUpdate
}: Props) => (
  <BaseCreditNoteLineItemDrawer
    isOpen={isOpen}
    onClose={onClose}
    creditNoteCurrency={currency}
    excludedProductIds={excludedProductIds}
    requireProduct
    initialValues={rowToFormValues(row)}
    initialTaxRate={row.taxRate}
    title="Edit line item"
    submitButtonText="Update"
    onSubmit={async values => {
      // Spread over the existing row to preserve identity (rowId, lineItemId,
      // groupId) and selection state.
      onUpdate({ ...row, ...submitValuesToRowFields(values) })
      return true
    }}
  />
)
